import { Select } from "antd";

const ListSelect = ({
  title,
  value,
  onChange,
  options,
  is_multi = false,
  selectTagRender,
}) => (
  <Select
    allowClear={!is_multi}
    style={{
      width: "100%",
      display: "block",
    }}
    placeholder={title}
    value={value}
    onChange={onChange}
    options={options}
    mode={is_multi && "tags"}
    tagRender={selectTagRender}
  />
);

export default ListSelect;
